export default __webpack_public_path__ + "static/media/D7.c08aad40.png";